module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isAcceptCookies) ? _c('div', {
    staticClass: "cookies"
  }, [_c('div', {
    staticClass: "cookies__inner"
  }, [_c('div', {
    staticClass: "cookies__box"
  }, [_c('button', {
    staticClass: "cookies__box--close",
    on: {
      "click": function($event) {
        _vm.setAcceptCookies()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/cookies__close.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cookies__box--text"
  }, [_vm._v(_vm._s(_vm.$lang.cookies.bar.text))]), _vm._v(" "), _c('a', {
    staticClass: "cookies__box--text cookies__box--link",
    on: {
      "click": function($event) {
        _vm.toggleCookieModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.cookies.bar.link))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActiveCookieModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$lang.cookies.modal.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.toggleCookieModal()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.$lang.cookies.modal.text)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea59efc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/Cookies.vue
// module id = 343
// module chunks = 1